import {MolecularGraph} from "../../graph/MolecularGraph"
import {extractorUtil} from "../../util/extractorUtil";
import {Feature, Features} from "../../feature";
import {rGroupFinder} from "../../util/rGroupFinder";

export const carbonylCoreExtractor = {
    extract: (graph: MolecularGraph) => {
        const carbonRoots = extractorUtil.getFunctionalGroupRootsWithElement("C", graph);
        const features: Feature[] = [];
        while(carbonRoots.length > 0) {
            const c = carbonRoots.pop()!;
            const oBonds = extractorUtil.getDoubleBondsToO(c, graph);
            // There can only be 1 double bond to O
            if(oBonds.length !== 1)
                continue;

            // For a carbonyl, it doesn't matter what's attached to
            // the O. It's still a carbonyl. But the R groups are
            // only attached to the C
            const o = oBonds[0].getOtherAtom(c);

            const a = [c, o];
            const r = rGroupFinder.get(graph, [c]);


            features.push({name: Features.carbonyl, atoms: a, connections: r.filter(a => a !== o)});
        }

        return features;

    }
}
